import React from 'react';
import PageMenu from 'components/blocks/PageMenu/PageMenu';
import usePageTitle from 'hooks/usePageTitle';
import SurveysGrid from 'components/blocks/Grids/SurveysGrid';
import { useGeneralManagementState } from '../GeneralManagement/generalManagementState';

const Surveys: React.FC = (props) => {
  usePageTitle('Mis Encuestas');
  const { state } = useGeneralManagementState();

  const isLoading = state.surveys == null;
  const hasSurveys = Array.isArray(state.surveys) && state.surveys.length > 0;

  return (
    <>
      <PageMenu title="Mis encuestas" breadcrumbs={["Mis encuestas"]} />
      <section className="container">
        <div className="row">
          <div className="col">
            {isLoading ? (
              <p className="loader-text">Cargando encuestas…</p>
            ) : hasSurveys ? (
              <SurveysGrid props={props} arrData={state.surveys} />
            ) : (
              <p className="loader-text">No hay encuestas disponibles en este momento.</p>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default Surveys;